import * as Data from './archibus-v2/DataApi'

export const fetchFloor = async ({blId}) => {
  let restriction = new Ab.view.Restriction()
  restriction.addClause('fl.bl_id', blId)

  const {data} = await Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'floors',
    restriction
  )

  const [firstFloor] = data
  return firstFloor ? firstFloor.flId : null
}
